let CookieConsent = require("./cookieconsent.umd.js")

/**
 * Enable suggestions
 * @type {import('../../types')}
 */
CookieConsent.run( {
    guiOptions: {
        consentModal: {
            layout: "box inline",
            position: "bottom left",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
            readOnly: true
        },
        functional: {},
        analytics: {},
        marketing: {}
    },
    language: {
        default: "en",
        autoDetect: "browser",
        translations: {
            en: {
                consentModal: {
                    title: "Cookies",
                    description: "We use cookies to help deliver a better experience to you. You can read our policy here: <a href=\"/cookie-policy\" target=\"_blank\">Learn more</a>",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject all",
                    showPreferencesBtn: "Manage preferences",
                },
                preferencesModal: {
                    title: "Cookies",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject all",
                    savePreferencesBtn: "Save preferences",
                    closeIconLabel: "Close modal",
                    serviceCounterLabel: "Service|Services",
                    sections: [
                        {
                            description: "We use cookies to help deliver a better experience to you. You can read our policy here: <a href=\"/cookie-policy\" target='_blank'>Learn more</a>"
                        },
                        {
                            title: "Strictly Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
                            description: "These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. These cookies do not store any personally identifiable information.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: 'Functional',
                            description: 'Functional cookies help perform certain functionalities like sharing the content of the website on social media platforms, collecting feedback, and other third-party features.',
                            linkedCategory: 'functional',
                        },
                        {
                            title: "Analytics Cookies",
                            description: "These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Marketing Cookies",
                            description: "These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites. They do not store directly personal information, but are based on uniquely identifying your browser and internet device. If you do not allow these cookies, you will experience less targeted advertising.",
                            linkedCategory: "marketing"
                        }
                    ]
                }
            }
        }
    }
} )
const updateGtagConsent = () => {
    console.log('consent update')
    gtag('consent', 'update', {
        'ad_storage': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        'ad_user_data': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        'ad_personalization': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        'analytics_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
        'functionality_storage': CookieConsent.acceptedCategory('functional') ? 'granted' : 'denied',
        'personalization_storage': CookieConsent.acceptedCategory('functional') ? 'granted' : 'denied',
        'security_storage': 'granted', //necessary
    });
};
window.addEventListener('cc:onConsent', () => {
    updateGtagConsent();
});
window.addEventListener('cc:onChange', () => {
    updateGtagConsent();
});
